import React from 'react';
import { AppRouter } from './AppRouter';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { useWhatsAppRealtime } from './hooks/useWhatsAppRealtime';

export function App() {
  return (
    <AuthProvider>
      <WhatsAppRealtimeBridgeProvider>
        <AppRouter />
      </WhatsAppRealtimeBridgeProvider>
    </AuthProvider>
  );
}

function WhatsAppRealtimeBridgeProvider({ children }: { children: React.ReactNode }) {
  // Enable realtime subscriptions
  // Note: useWhatsAppRealtime internally checks for userId, so it's safe to always call
  useWhatsAppRealtime();

  return <>{children}</>;
}
